import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  deliveryStepsList: {
    padding: "8px 0",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  buttons_container: {
    display: "flex",
    gap: "5px"
  },
  deliveryStepItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "12px 16px !important",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${theme.palette?.divider || "#e0e0e0"}`,
    cursor: "grab",
    transition: "all 0.2s ease",
    flexWrap: "wrap",
    gap: "12px",
    "&:hover": {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12)",
      borderColor: theme.palette?.primary?.light || "#64b5f6",
    },
    "&.dragging": {
      opacity: 0.7,
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
      transform: "scale(1.02)",
    },
  },
  deliveryStepContent: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: "1 1 auto",
    minWidth: "200px",
  },
  dragHandle: {
    display: "flex",
    alignItems: "center",
    color: "#9e9e9e",
    cursor: "grab",
    "&:hover": {
      color: "#616161",
    },
  },
  orderNumber: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: "#26a69a",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    fontSize: "14px",
    flexShrink: 0,
  },
  deliveryStepInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
    flex: 1,
  },
  deliveryStepName: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#212121",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  deliveryStepId: {
    fontSize: "12px",
    color: "#757575",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  costInputsContainer: {
    display: "flex",
    gap: "8px",
    flex: "1 1 auto",
    minWidth: "280px",
    alignItems: "center",
  },
  costInput: {
    flex: 1,
    minWidth: "120px",
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexShrink: 0,
  },
  status_container: {
    width: "135px",
  },
  statusPending: {
    backgroundColor: "#ff9800",
    color: "#ffffff",
  },
  statusInProgress: {
    backgroundColor: "#2196f3",
    color: "#ffffff",
  },
  statusDelivered: {
    backgroundColor: "#4caf50",
    color: "#ffffff",
  },
  deleteButton: {
    color: "#9e9e9e",
    padding: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#f44336",
      backgroundColor: "rgba(244, 67, 54, 0.08)",
    },
  },
  saveButton: {
    marginTop: "20px",
    padding: "12px 24px",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "uppercase",
    borderRadius: "6px",
    backgroundColor: "#2196f3",
    boxShadow: "0 2px 4px rgba(33, 150, 243, 0.3)",
    "&:hover": {
      backgroundColor: "#1976d2",
      boxShadow: "0 4px 8px rgba(33, 150, 243, 0.4)",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0",
      color: "#9e9e9e",
      boxShadow: "none",
    },
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px",
    color: "#9e9e9e",
    textAlign: "center",
  },
  emptyStateIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    color: "#bdbdbd",
  },
  readOnlyItem: {
    backgroundColor: "#f5f5f5",
    opacity: 0.8,
    cursor: "default !important",
    "&:hover": {
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
      borderColor: theme.palette?.divider || "#e0e0e0",
    },
  },
}));

export { useStyles };
